import React from 'react';

interface TreeItemLabelProps {
  text: string;
  /** Optional icon element displayed before the text */
  statusIcon?: React.ReactNode;
  /** Optional secondary text displayed under the main label */
  subText?: string;
  /** Optional search term to highlight in the text */
  searchTerm?: string;
}

const TreeItemLabel: React.FC<TreeItemLabelProps> = ({
  text,
  statusIcon,
  subText,
  searchTerm,
}) => {
  // Helper function to highlight search text
  const highlightSearchText = (text: string, searchTerm?: string) => {
    if (!searchTerm || !text) return text;
    
    const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    const parts = text.split(regex);
    
    return parts.map((part, index) => 
      regex.test(part) ? 
        <span key={index} style={{ backgroundColor: '#ffeb3b', fontWeight: 'bold', padding: '1px 2px', borderRadius: '2px' }}>{part}</span> : 
        part
    );
  };

  return (
    <div
      className="tree-item-label"
      title={text}
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', position: 'relative' }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
        {statusIcon}
        <span
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'block', // Required for text-overflow to work on a span
          }}
        >
          {highlightSearchText(text, searchTerm)}
        </span>
      </span>
      {subText && (
        <span style={{ fontSize: '0.75rem', color: '#666' }}>
          {highlightSearchText(subText, searchTerm)}
        </span>
      )}
    </div>
  );
};

export default TreeItemLabel;
